import React from 'react';
import { Warehouse, Truck, Package, ClipboardCheck, BarChart3, Route, Boxes } from 'lucide-react';

const ServicesOverview = () => {
  const services = [
    {
      icon: Warehouse,
      title: 'Sandėliavimas',
      description: 'Trumpalaikis ir ilgalaikis prekių saugojimas moderniame sandėlyje.',
      image: '/images/photo-1645736315000-6f788915923b.jpeg'
    },
    {
      icon: Truck,
      title: 'Krovos darbai',
      description: 'Mechanizuotas ir rankinis pakrovimas bei iškrovimas.',
      image: '/images/photo-1714627798569-b3e36d409c4b.jpeg'
    },
    {
      icon: Package,
      title: 'Prekių paruošimas',
      description: 'Komplektavimas, perpakavimas, ženklinimas, svėrimas.',
      image: '/images/photo-1761195696590-3490ea770aa1.jpeg'
    },
    {
      icon: ClipboardCheck,
      title: 'Užsakymų valdymas',
      description: 'Tikslus prekių atrinkimas pagal FIFO ir FEFO metodus.',
      image: '/images/photo-1604233707683-fac593c74600.jpeg'
    },
    {
      icon: BarChart3,
      title: 'Apskaita ir kontrolė',
      description: 'Nuolatinė atsargų kontrolė ir ataskaitos.',
      image: '/images/photo-1764745021344-317b80f09e40.jpeg'
    },
    {
      icon: Route,
      title: 'Logistikos organizavimas',
      description: 'Pakavimas ir transportavimo sprendimų derinimas.',
      image: '/images/photo-1758542113402-b46079642dc9.jpeg'
    },
    {
      icon: Boxes,
      title: '3PL logistika',
      description: 'Pilnas sandėliavimo ir distribucijos procesų valdymas.',
      image: '/images/pexels-photo-35501718.jpeg'
    },
  ];

  return (
    <section className="py-16 bg-gray-50" data-testid="services-overview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Mūsų paslaugos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visapusiški logistikos sprendimai, pritaikyti jūsų verslo poreikiams
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
                data-testid={`service-card-${index}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-blue-600 p-3 rounded-lg">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
